// const getKeyFromObject = (object, value) => Object.keys(object)[Object.values(object).indexOf(value)]

export default ({ app }, inject) => {
  inject('getKeyFromObject', (object, value) => Object.keys(object)[Object.values(object).indexOf(value)])
}

// Export the function directly
export const getKeyFromObject = (object, value) => Object.keys(object)[Object.values(object).indexOf(value)]
